import MintTokens from "../../../components/actions/NFTs/mintTokens";
const MintErc1155 = () => {
  return (
    <>
      <MintTokens tokenType="Erc1155" />
    </>
  );
};

export default MintErc1155;